import { Box, useTheme } from "@mui/material";
import { BotMessage } from "@pages:app/talk/Chat/components/message-view/BotMessage";
import { UserMessage } from "@pages:app/talk/Chat/components/message-view/UserMessage";
import { ChatMessage } from "@pages:app/talk/Chat/components/utils/message";
import { Sender } from "@pages:app/talk/const";
import { Reference } from "@pages:app/talk/shared/Reference";
import { useState } from "react";

interface MessageProps {
  message: ChatMessage;
}

export const Message = ({ message }: MessageProps) => {
  const theme = useTheme();
  const { sender, text, references, key, messageId } = message;

  const [showReferences, setShowReferences] = useState(false);

  return (
    <Box
      key={key}
      sx={{
        width: "100%",
        border: 0,
        background: "transparent",
      }}
    >
      <Box
        sx={{
          margin: "auto",
          justifyContent: "center",
          padding: "0.75rem 1rem",
        }}
      >
        <Box
          sx={{
            marginX: "auto",
            display: "flex",
            flex: "1 1 0%",
            gap: "0.75rem",
            fontSize: "1rem",
            lineHeight: "1.5",
            [theme.breakpoints.up("sm")]: {
              maxWidth: "56rem",
            },
            [theme.breakpoints.up("md")]: {
              maxWidth: "52rem",
            },
            [theme.breakpoints.up("lg")]: {
              maxWidth: "58rem",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            {sender === Sender.User ? (
              <UserMessage message={text} />
            ) : (
              <BotMessage
                showReferences={showReferences}
                setShowReferences={setShowReferences}
                text={text}
                references={references!}
                messageId={messageId}
              />
            )}
            {showReferences && (
              <Box
                sx={{
                  marginTop: "1rem",
                  padding: "1rem ",
                  borderRadius: "30px",
                  borderTopLeftRadius: "0",
                  border: "1px solid #F0FAFA",
                  boxShadow: "0px 8px 24px 0px #00000040",
                }}
              >
                <Reference references={references ?? []} showContent />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
